import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ScreenAndProtectReservationType } from 'models/ScreenAndProtect';
import DisplayValue from '../common/displayValue/DisplayValue';
import SummaryRow from './SummaryRow';
import { StyledReservationSummary } from './ReservationSummary.styled';
import StartDateField from './fields/StartDateField';

interface ReservationSummaryProps {
  reservationType: ScreenAndProtectReservationType;
  startDate: string;
  isEditable?: boolean;
}

const ReservationSummary: FC<ReservationSummaryProps> = (props) => {
  const { reservationType, startDate, isEditable = true } = props;
  const { t } = useTranslation();

  return (
    <StyledReservationSummary>
      <DisplayValue
        label={t(
          'pageScreenAndProtect.detailsPage.sections.protectionDetails.startDate',
        )}
        value={
          <div className="summary">
            {reservationType === 'all' && (
              <div className="summary-inner-wrapper">
                <SummaryRow
                  label={t(
                    'pageScreenAndProtect.detailsPage.sections.protectionDetails.existingReservationsLabel',
                  )}
                  value={t(
                    'pageScreenAndProtect.detailsPage.sections.protectionDetails.existingReservationsValue',
                  )}
                />
                {isEditable ? (
                  <StartDateField />
                ) : (
                  <span>
                    {t(
                      'pageScreenAndProtect.detailsPage.sections.protectionDetails.startDateValue',
                      { date: startDate },
                    )}
                  </span>
                )}
              </div>
            )}

            <SummaryRow
              label={t(
                'pageScreenAndProtect.detailsPage.sections.protectionDetails.newBookingsLabel',
              )}
              value={t(
                'pageScreenAndProtect.detailsPage.sections.protectionDetails.newBookingsValue',
              )}
            />
          </div>
        }
        valueDataIntercomTarget="details-screen-protect-start-date"
      />
    </StyledReservationSummary>
  );
};

ReservationSummary.defaultProps = {
  isEditable: true,
};

export default ReservationSummary;
